export default __webpack_public_path__ + "static/media/748-tile.f2990da4.svg";